import React from 'react';

interface Props {
  status: 'Active' | 'Trial' | 'Suspended' | 'Expired' | string;
}

const statusClass = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'active':
      return 'pill success';
    case 'trial':
      return 'pill warning';
    case 'suspended':
    case 'expired':
      return 'pill danger';
    default:
      return 'pill';
  }
};

export const StatusBadge = ({ status }: Props): JSX.Element => (
  <span className={statusClass(status)}>{status}</span>
);
